module.exports = __webpack_public_path__ + "img/content4-1.0217bbd1.png";